import React from 'react';
import { TCITooltip } from '@/components/ui/Tooltip';
import { Collapse } from '../../../../images/react/Collapse';
import { Expand } from '../../../../images/react/Expand';
import { HEADER_BUTTON_CLASSES, TRANSLATIONS, usePlanningDrawer } from './utils';

export const ExpandCollapseButton = () => {
  const { isExpanded, toggleExpanded } = usePlanningDrawer();
  const message = isExpanded ? TRANSLATIONS.dialog.collapse : TRANSLATIONS.dialog.expand;

  return (
    <TCITooltip>
      <TCITooltip.Trigger asChild>
        <button
          aria-label={message}
          className={HEADER_BUTTON_CLASSES}
          type="button"
          onClick={toggleExpanded}
        >
          {isExpanded ? <Collapse fill={null} height={12} width={12} /> : <Expand fill={null} height={12} width={12} />}
        </button>
      </TCITooltip.Trigger>
      <TCITooltip.Content>
        {message}
      </TCITooltip.Content>
    </TCITooltip>
  );
};
